export const JUGADOR = 'J';
export const TECNICO = 'T';
export const OTROS = 'X';
